import { defineComponent as _defineComponent } from 'vue'
import i18n from '@/plugins/i18n';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailPreviewFrame',
  props: {
  subject: { type: Object as PropType<string | null | undefined>, required: false, default: undefined },
},
  setup(__props) {

const props = __props;




return { __sfc: true,props, i18n }
}

})